import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { ConfigService } from '../config.service';

export const ppjGuard: CanActivateFn = (): boolean | UrlTree => {
  const configService = inject(ConfigService);
  const router = inject(Router);

  if (!configService.enablePpj) {
    return router.createUrlTree(['/']);
  }

  return true;
};
